import React from "react";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { AccountBox, Face } from "@material-ui/icons";
import { fade } from "@material-ui/core/styles/colorManipulator";
import { ThemeType } from "@theme";
import locale from "@bonliva-crm/locale";
import { CustomerContactList_ItemFragment as Item } from "@graphql";
import IconTitle from "@components/ItemCard/IconTitle";
import { emailToDetail, phoneToDetails } from "@components/ItemCard/CardDetails";

type Props = {
  data: Item[];
};

export function CustomerContactList(props: Props) {
  const { data } = props;
  const classes = useStyles({});

  return (
    <div>
      {data.map((x) => (
        <Grid key={x._id} container className={classes.detailRow}>
          <Grid item xs={3}>
            <IconTitle icon={<Face />} title={locale.NameAndTitle}>
              {x.Name},<br /> {x.Title}
            </IconTitle>
          </Grid>

          <Grid item xs={3}>
            <IconTitle icon={<AccountBox />} title={locale.Roles}>
              {x.Roles.map((r, i) => (
                <span key={r + i}>
                  {r}
                  <br />
                </span>
              ))}
            </IconTitle>
          </Grid>

          <Grid item xs={3}>
            {emailToDetail(x.Email)}
          </Grid>

          <Grid item xs={2}>
            {phoneToDetails(x.Phone)}
          </Grid>
        </Grid>
      ))}
    </div>
  );
}

const useStyles = makeStyles((theme: ThemeType) => ({
  detailRow: {
    alignItems: "center",
    justifyContent: "center",
    marginTop: theme.spacing(),

    "&:hover": {
      backgroundColor: fade(theme.palette.text.primary, theme.palette.action.hoverOpacity)
    }
  }
}));
